/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Profile_Avatar_Uploadingwithprogress2Inputs */

const id_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mengunggah... ${i?.progress}%`)
};

const ms_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Memuat naik... ${i?.progress}%`)
};

const da_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploader... ${i?.progress}%`)
};

const de_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hochladen... ${i?.progress}%`)
};

const en_us2_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading... ${i?.progress}%`)
};

const es_es2_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subiendo... ${i?.progress}%`)
};

const es_mx2_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subiendo... ${i?.progress}%`)
};

const fil_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nag-u-upload... ${i?.progress}%`)
};

const fr_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Téléversement… ${i?.progress}%`)
};

const it_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caricamento... ${i?.progress}%`)
};

const hu_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feltöltés... ${i?.progress}%`)
};

const nl_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bezig met uploaden... ${i?.progress}%`)
};

const no_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laster opp... ${i?.progress}%`)
};

const pl_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Przesyłanie... ${i?.progress}%`)
};

const pt_br2_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviando... ${i?.progress}%`)
};

const pt_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A carregar... ${i?.progress}%`)
};

const ro_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se încarcă... ${i?.progress}%`)
};

const fi_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ladataan... ${i?.progress}%`)
};

const sv_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laddar upp... ${i?.progress}%`)
};

const vi_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang tải lên... ${i?.progress}%`)
};

const tr_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yükleniyor... ${i?.progress}%`)
};

const cs_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nahrávání... ${i?.progress}%`)
};

const bg_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Качване... ${i?.progress}%`)
};

const ru_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загрузка... ${i?.progress}%`)
};

const uk_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Завантаження... ${i?.progress}%`)
};

const ar_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل... ${i?.progress}%`)
};

const hi_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अपलोड हो रहा है... ${i?.progress}%`)
};

const th_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กำลังอัปโหลด... ${i?.progress}%`)
};

const ja_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アップロード中... ${i?.progress}%`)
};

const zh_cn2_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在上传... ${i?.progress}%`)
};

const zh_hant1_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在上傳... ${i?.progress}%`)
};

const ko_profile_avatar_uploadingwithprogress2 = /** @type {(inputs: Profile_Avatar_Uploadingwithprogress2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`업로드 중... ${i?.progress}%`)
};

/**
* | output |
* | --- |
* | "Uploading... {progress}%" |
*
* @param {Profile_Avatar_Uploadingwithprogress2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_uploadingwithprogress2 = /** @type {((inputs: Profile_Avatar_Uploadingwithprogress2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_Uploadingwithprogress2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "ms") return ms_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "da") return da_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "de") return de_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "fil") return fil_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "fr") return fr_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "it") return it_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "hu") return hu_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "nl") return nl_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "no") return no_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "pl") return pl_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "pt") return pt_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "ro") return ro_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "fi") return fi_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "sv") return sv_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "vi") return vi_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "tr") return tr_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "cs") return cs_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "bg") return bg_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "ru") return ru_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "uk") return uk_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "ar") return ar_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "hi") return hi_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "th") return th_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "ja") return ja_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_uploadingwithprogress2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_uploadingwithprogress2(inputs)
	return ko_profile_avatar_uploadingwithprogress2(inputs)
});
export { profile_avatar_uploadingwithprogress2 as "profile.avatar.uploadingWithProgress" }